import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import { expr } from '@codegrade/utils';
import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import PageTitle from '@/components/PageTitle';
import * as utils from '@/utils';
import srcLogoLight from '../../../static/img/codegrade-gradient-light.svg';
import srcLogoDark from '../../../static/img/codegrade.svg';
const clsBrandArea = ['bg-white dark:bg-brand-65'];
const clsLogo = 'max-w-52';
const clsTitleCommon = 'm-0 text-brand-60 dark:text-brand-10';
const clsLink = 'dark:text-actionable-20';
const aboutUrl = 'https://www.codegrade.com/company/about';
const privacyUrl = 'https://www.codegrade.com/privacy-policy';
/** Base page layout for pre-login pages. */
export const Layout = tsx.component({
    name: 'pre-login-page-layout',
    functional: true,
    props: {
        previousStep: p.ofType().optional,
        pageTitle: p(String).required,
        secondaryTitle: p(String).optional,
    },
    /** @returns Body of the component. */
    render(h, ctx) {
        const { pageTitle, secondaryTitle, previousStep } = ctx.props;
        const defaultSlot = ctx.slots().default;
        return (<div attrs={ctx.data.attrs} class={[
                ctx.data.class,
                ctx.data.staticClass,
                'grow',
                'flex flex-col', // Use flex on mobile
                'md:grid md:grid-cols-3 md:grid-rows-2', // use Grid on desktop
                'text-brand-90 dark:text-brand-10',
            ]}>
                <PageTitle pageTitle={secondaryTitle != null ? `${secondaryTitle} | ${pageTitle}` : pageTitle}/>
                <header class={[clsBrandArea, 'p-6 max-md:pt-8 max-md:text-center']}>
                    <img alt="CodeGrade Logo" src={srcLogoDark} class={[clsLogo, 'not-dark:hidden']}/>
                    <img alt="CodeGrade Logo" src={srcLogoLight} class={[clsLogo, 'dark:hidden']}/>
                </header>
                <section class={[
                'flex-auto',
                'flex flex-col gap-3 justify-start md:justify-center',
                'bg-brand-2 dark:bg-brand-75',
                'col-start-2 col-span-2 row-span-full',
                'p-3 md:py-6 md:pl-9',
                'overflow-auto',
            ]}>
                    <div>
                        {utils.emptyIfNil(previousStep, (step) => {
                const clsPrevBtn = 'inline-flex h-full hover:no-underline hover:bg-white dark:hover:bg-brand-70';
                return expr.match(step, 'tag', {
                    button: ({ action }) => (<Button semantic="neutral" prominence={1} action={action} class={clsPrevBtn}>
                                        <Icon icon={icons.ChevronLeft}/> Previous Step
                                    </Button>),
                    link: ({ to }) => (<router-link to={to} class={[clsPrevBtn, 'cg-btn btn-neutral-1']}>
                                        <Icon icon={icons.ChevronLeft}/> Previous Step
                                    </router-link>),
                });
            })}
                    </div>
                    <div class="shrink flex flex-col gap-6 pl-2">
                        <h1 class={['headline-large', clsTitleCommon]}>{pageTitle}</h1>
                        {utils.emptyIfNil(secondaryTitle, text => (<h2 class={['title-medium', clsTitleCommon]}>{text}</h2>))}
                        <div class="shrink flex flex-col gap-6 max-w-180 pb-2">
                            {/*
            To have scrollable children that respect parent height in this element,
            assign classes: `flex-auto basis-0 overflow-auto`
            */}
                            {defaultSlot}
                        </div>
                    </div>
                </section>
                <footer class={[
                clsBrandArea,
                'row-start-2',
                'p-3!',
                'flex items-end justify-between',
                'label-small',
                'text-brand-50 dark:text-brand-10',
                '@container',
            ]}>
                    <span>
                        <a class={clsLink} href={aboutUrl} target="_blank" rel="noopener noreferrer">
                            codegrade<span class="@max-xs:sr-only">.com</span>
                        </a>{' '}
                        made with ❤️
                    </span>
                    <a class={clsLink} href={privacyUrl} target="_blank" rel="noopener noreferrer">
                        privacy<span class="@max-xs:sr-only"> statement</span>
                    </a>
                </footer>
            </div>);
    },
});
